// extracted by mini-css-extract-plugin
export default {"container":"c0-z","title":"d0-z","link":"e0-z"};